import { Button } from '@iwoca/orion';
import styles from './TourSelection.module.css';

type TProps = {
  name: string;
  description: string;
  onClick: () => void;
};

export const TourSelection = ({ name, description, onClick }: TProps) => {
  return (
    <div className={styles.container}>
      <div>
        <h5 className={styles.name}>{name} tour</h5>
        <p className={styles.description}>{description}</p>
      </div>
      <Button size="small" onClick={onClick}>
        Start tour
      </Button>
    </div>
  );
};
